/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_HintInputs */

const cs_draft_hint = /** @type {(inputs: Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jako přepsání se odešlou jen pole, která změníte. Nechte pole beze změny pro automatické vyplnění. Vyprázdněním slotu fotku vynecháte.`)
};

const en_draft_hint = /** @type {(inputs: Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only fields you change are sent as overrides. Leave a field as-is to keep autofill. Clear a photo slot to omit it.`)
};

/**
* | output |
* | --- |
* | "Only fields you change are sent as overrides. Leave a field as-is to keep autofill. Clear a photo slot to omit it." |
*
* @param {Draft_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_hint = /** @type {((inputs?: Draft_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_hint(inputs)
	return cs_draft_hint(inputs)
});